import { useRef, useState } from "react";

export default function BeforeAfterSlider() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const setFromClientX = (clientX: number) => {
    const rect = trackRef.current?.getBoundingClientRect();
    if (!rect) return;
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, pct)));
  };

  return (
    <div
      className="ba"
      id="ba"
      ref={trackRef}
      style={{ "--pos": `${pos}%` } as React.CSSProperties}
      onPointerDown={(e) => {
        if ((e.target as HTMLElement).closest(".ba-grip")) return;
        setFromClientX(e.clientX);
      }}
      onPointerMove={(e) => {
        if (dragging.current) setFromClientX(e.clientX);
      }}
      onPointerUp={() => {
        dragging.current = false;
      }}
    >
      <div className="ba-layer" aria-label="After — corrected and coated panel" />
      <div className="ba-layer ba-top" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} aria-label="Before — same panel, same light" />
      <span className="ba-tag" style={{ left: "var(--space-5)" }}>
        Before
      </span>
      <span className="ba-tag" style={{ right: "var(--space-5)" }}>
        After
      </span>
      <div className="ba-handle" style={{ left: `${pos}%` }} />
      <div
        className="ba-grip"
        role="slider"
        tabIndex={0}
        aria-label="Reveal before and after"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(pos)}
        style={{ left: `${pos}%` }}
        onPointerDown={(e) => {
          dragging.current = true;
          (e.target as HTMLElement).setPointerCapture(e.pointerId);
        }}
        onPointerUp={() => {
          dragging.current = false;
        }}
        onKeyDown={(e) => {
          if (e.key === "ArrowLeft") {
            setPos((p) => Math.max(0, p - 4));
            e.preventDefault();
          }
          if (e.key === "ArrowRight") {
            setPos((p) => Math.min(100, p + 4));
            e.preventDefault();
          }
        }}
      >
        ↔
      </div>
    </div>
  );
}
